/**
 *
 */
// eslint-disable-next-line no-unused-vars
function getLCCustomVars() {
  return [
    { name: 'ab_test_var', value: $.cookie('AB_TEST_VAR') },
    { name: 'visitor_ip', value: $.cookie('VISITOR_IP') },
    { name: 'gaui', value: $.cookie('GAUI') },
    { name: 'language', value: window.navigator.userLanguage || window.navigator.language || 'N/A' }
  ];
}
